/**
 * Mordeczka.eu Admin - Dictionary Pages using Ant Design
 */

import { DictionaryPage } from "./DictionaryPage";
import {
  languagesApi,
  tagsApi,
  genresApi,
  literaryGenresApi,
  publishersApi,
  directorsApi,
  subscriptionTypesApi,
} from "../services/api";

export function LanguagesPage() {
  return (
    <DictionaryPage title="Języki" queryKey="languages" api={languagesApi} />
  );
}

export function TagsPage() {
  return <DictionaryPage title="Tagi" queryKey="tags" api={tagsApi} />;
}

export function GenresPage() {
  return <DictionaryPage title="Gatunki" queryKey="genres" api={genresApi} />;
}

export function LiteraryGenresPage() {
  return (
    <DictionaryPage
      title="Gatunki literackie"
      queryKey="literary-genres"
      api={literaryGenresApi}
    />
  );
}

export function PublishersPage() {
  return (
    <DictionaryPage
      title="Wydawnictwa"
      queryKey="publishers"
      api={{
        list: publishersApi.list,
        create: (data: { name: string }) => publishersApi.create(data),
        update: (id: string, data: { name?: string }) =>
          publishersApi.update(id, data),
        delete: publishersApi.delete,
      }}
    />
  );
}

export function DirectorsPage() {
  return (
    <DictionaryPage
      title="Reżyserzy"
      queryKey="directors"
      api={{
        list: directorsApi.list,
        create: (data: { name: string }) => directorsApi.create(data),
        update: (id: string, data: { name?: string }) =>
          directorsApi.update(id, data),
        delete: directorsApi.delete,
      }}
    />
  );
}

export function SubscriptionTypesPage() {
  return (
    <DictionaryPage
      title="Typy abonamentów"
      queryKey="subscription-types"
      api={subscriptionTypesApi}
    />
  );
}
